<script lang="ts" setup>
  import type { PlayerSession } from '../../../../shared/api/player.ts';
  import { Button } from '../../../../shared/ui/button';
  import SpotifySignInButton from './SpotifySignInButton.vue';

  defineProps<{ session: PlayerSession }>();
  defineEmits<{ rejoin: []; spotifySignIn: [] }>();
</script>

<template>
  <p class="session">
    You are currently in game <strong>{{ session.gameCode }}</strong> as
    <strong class="nickname">{{ session.nickname }}</strong>
  </p>
  <div class="rejoin-action">
    <Button type="button" @click="$emit('rejoin')">Rejoin game</Button>
  </div>
  <p class="new-game-hint">Or create a new game by signing in with Spotify again.</p>
  <SpotifySignInButton type="button" @click="$emit('spotifySignIn')">Sign in with Spotify</SpotifySignInButton>
</template>

<style scoped>
  .session {
    column-gap: 0.25em;
    display: flex;
    flex-wrap: wrap;
    font-size: var(--font-size-md);
    height: 3rem;
    margin: 0;
    place-content: center center;
    text-align: center;
    width: 100%;
  }

  strong {
    color: var(--color-primary);
  }

  .nickname {
    white-space: nowrap;
  }

  .new-game-hint {
    font-size: var(--font-size-md);
    margin: 0;
    text-align: center;
  }

  .rejoin-action {
    display: flex;
    justify-content: center;
    min-height: 3.5rem;
    width: 100%;
  }
</style>
